// @Version: 1.0.1
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IErrorCodes } from '../../../services/errorMessages/error-messages.model';
import { ErrorMessagesService } from '../../../services/errorMessages/error-messages.service';
import ICheckboxModel from './checkbox.model';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TRANSLATE_PATH } from 'src/app/shared/shared.model';

UntilDestroy()
@Injectable()
export class FieldItemCheckboxService  {

   private values_: ICheckboxModel[] = [];
   private errorCodes_: IErrorCodes = {} as IErrorCodes;
   private validList_: string[] = [];
   private required_: boolean = false;
 
   set required (required: boolean) {
      this.required_ = required;
   }

   get required (): boolean {
      return this.required_;
   }

   get errorCodes (): IErrorCodes {
      return this.errorCodes_;
   }
   set errorCodes (value: IErrorCodes) {
      this.errorCodes_ = value;
   }

   get values (): ICheckboxModel[] {
      return this.values_;
   }

   get validList (): string[] {
      return this.validList_;
   }

   constructor (private sErrorMessage: ErrorMessagesService) { }

   public reset (): void {
      this.values_ = [];
      this.errorCodes_ = {} as IErrorCodes;
      this.validList_ = [];
      this.required_ = false;
   }

   public getSelection (fg: FormGroup): string {
      if (Object.keys(fg.controls).length == 0) return '';

      let selection = [] as string[];
      Object.keys(fg.controls).forEach((element, index) => {
         if (fg.get(element)?.value) selection.push(this.values_[index].value);
      });

      return selection.join(';');
   }

   public createValues (attribute: string): boolean {
      if (!attribute) {
         this.values_ = [];
         return false;
      }
      
      let splitAttribute1 = attribute.split(';');
      splitAttribute1.forEach((elem) => {
         this.values_.push({
            value: elem.split(":")[0],
            label: elem.substring(elem.indexOf(':')+1)
         })
      });
      
      return true;
   }

   public createErrorMessages (errorMessage: string): boolean {
      this.errorCodes_ =  this.sErrorMessage.setErrorCodes(errorMessage, TRANSLATE_PATH.FIELD_ITEM_ERROR);
      return true;
   }

   public createValidList (list: string): boolean {
      if (!list) {
         this.validList_ = [];
         return false;
      }
      let splitValidList = list.split(';');

      splitValidList.forEach((elem) => this.validList_.push(elem));

      return true;
   }
}